export default "__VITE_ASSET__CZnvz30i__"